module.exports = __webpack_public_path__ + "img/hlwpt_banner_img.e204f7de.png";